import { render, staticRenderFns } from "./ProductRecordModal.vue?vue&type=template&id=3ad4f2e0"
import script from "./ProductRecordModal.vue?vue&type=script&lang=js"
export * from "./ProductRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports